import React from "react";
import useOkendo from "hooks/useOkendo";

const OkendoBadge = ({ data }) => {
	const widgetContainer = useOkendo();

	return (
		<div className="flex justify-center m-5">
			<div
				ref={widgetContainer}
				data-oke-badge
				data-oke-layout={data.size}
				data-oke-color-scheme="dark"
				{...(data === "small" && { "data-oke-star-height-px": "16" })}
			/>
		</div>
	);
};

export default OkendoBadge;
